import { Action } from "../components/Actions";
import { EditorialShell } from "../components/EditorialShell";
import { DIMENSION_DESCRIPTIONS, DIMENSION_LABELS } from "../logic/dimensions";
import { INTERNAL_DIMENSIONS } from "../types";

export function GuideScreen({ onContinue, onBack }: { onContinue(): void; onBack(): void }) {
  return (
    <EditorialShell>
      <section className="guide-page page-enter">
        <h1>九次选择，<br />不需要标准答案。</h1>
        <p className="guide-lead">接下来会依次打开九张专辑。每张专辑，请选一首你最喜欢，或者最能代表自己的歌。</p>
        <ol className="guide-steps">
          <li><span>01</span><p>每张专辑选 1 首，共选出 9 首。</p></li>
          <li><span>02</span><p>选择只保存在你的浏览器里，不会上传。</p></li>
          <li><span>03</span><p>系统按固定规则计算；同样答案始终得到同样结果。</p></li>
        </ol>
        <section className="dimension-glossary" aria-labelledby="dimensions-guide-title">
          <h2 id="dimensions-guide-title">六个观察方向</h2>
          {INTERNAL_DIMENSIONS.map((dimension) => (
            <article key={dimension}>
              <h3>{DIMENSION_LABELS[dimension]}</h3>
              <p>{DIMENSION_DESCRIPTIONS[dimension]}</p>
            </article>
          ))}
        </section>
        <div className="flow-actions">
          <Action onClick={onContinue}>打开第一张专辑</Action>
          <Action tone="text" onClick={onBack}>返回首页</Action>
        </div>
      </section>
    </EditorialShell>
  );
}
